import React, { Component } from 'react';
import { Inputs } from '../components/Inputs';
import { StartingDialog } from '../components/StartingDialog';
import { Graph } from '../components/Graph';
import { formatToNumber, getTooltipValue } from '../utils/Format';
import { computeData } from '../utils/Computations';
import { Container, Row, Col } from 'reactstrap';
import { BarChart } from 'react-bootstrap-icons';


export class Home extends Component {
    constructor(props) {
        super(props);
        this.handleModalSubmit = this.handleModalSubmit.bind(this);
        this.updateState = this.updateState.bind(this);
        this.reCompute = this.reCompute.bind(this);
        this.valueUpDown = this.valueUpDown.bind(this);
        this.recomputeTimer = null;
        this.state = {
            currentAge: 0,
            retirementAge: 0,
            currentComp: 0,
            compRate: 0,
            deferralPercentage: 0,
            catchUpAmount: 0,
            est401Return: 0,
            current401: 0,
            beginningSharesHeld: 0,
            assumedPercentageIncreaseShares: 0,
            assumedPercentageIncreaseDividends: 0,
            assumedPercentageIncreaseCash: 0,
            openingCashBalance: 0,
            totalRetirement: 0,
            totalESOP: 0,
            totalFunds: 0,
            StartingDividendLevel: 0,
            CurrentMarketValueOfShares: 0,
            MaxCatchUpContribution: 7500, // Default value, will be replaced with DB value
            chartData: [],
            showModal: true,
            showGraph: false,
            isLoading: true,
            error: null,
            helpTextData: null,
            defaultItemData: null,
            inputData: null
        };
    }

    handleModalSubmit = async (event, isValid) => {
        event.preventDefault();

        if (isValid) {
            let compFormatted = formatToNumber(event.target.current_comp.value); //remove the commas that were added
            const newState = {
                currentAge: Number(event.target.current_age.value),
                retirementAge: Number(event.target.retirement_age.value),
                currentComp: compFormatted,
                compRate: Number(event.target.comp_rate.value),
                showModal: false
            };

            this.setState(newState, async () => {
                try {
                    const computations = await computeData(this.state);

                    this.setState({
                        showGraph: true,
                        chartData: computations.annualResults,
                        totalRetirement: computations.total401k,
                        totalESOP: computations.totalESOP,
                        totalFunds: computations.totalRetirement
                    });
                }
                catch (err) {
                    console.error(err);
                }
            });
        }
    };

    debouncedRecompute = (delay = 300) => {
        clearTimeout(this.recomputeTimer);
        this.recomputeTimer = setTimeout(() => this.reCompute(), delay);
    };

    updateState(value, stateToUpdate, shouldRecompute) {
        this.setState({ [stateToUpdate]: value }, () => {
            if (shouldRecompute) this.debouncedRecompute(300);
        });
    }

    valueUpDown(direction, stateToUpdate, increment) {
        const startingValue = formatToNumber(this.state[stateToUpdate]);
        const nextValue = direction === "up" ? startingValue + increment : Math.max(0, startingValue - increment);
        this.updateState(nextValue, stateToUpdate, true);
    }



    reCompute = async () => {
        let computations = await computeData(this.state);

        this.setState({
            chartData: computations.annualResults,
            totalESOP: computations.totalESOP,
            totalRetirement: computations.total401k,
            totalFunds: computations.totalRetirement
        });
    };

    componentDidMount() {
        let audienceType = this.props.audience;

        fetch(`/api/HelpText`)
            .then((response) => {
                return response.json();
            })
            .then((responseData) => {
                this.setState({ helpTextData: responseData });
                this.setState({ error: null });
            })
            .catch((err) => {
                this.setState({ error: err.message });
                this.setState({ helpTextData: null });
            })
            .finally(() => {
                fetch(`/api/DefaultItem`)
                    .then((response) => {
                        return response.json();
                    })
                    .then((responseData) => {
                        this.setState({ deferralPercentage: getTooltipValue(responseData, audienceType, 2) });
                        this.setState({ est401Return: getTooltipValue(responseData, audienceType, 3) });
                        this.setState({ assumedPercentageIncreaseShares: getTooltipValue(responseData, audienceType, 4) });
                        this.setState({ assumedPercentageIncreaseDividends: getTooltipValue(responseData, audienceType, 6) });
                        this.setState({ assumedPercentageIncreaseCash: getTooltipValue(responseData, audienceType, 7) });
                        this.setState({ error: null });
                    })
                    .catch((err) => {
                        this.setState({ error: err.message });
                        this.setState({ defaultItemData: null });
                    })
                    .finally(() => {
                        fetch(`/api/StaticValue/MaxCatchUpContribution`)
                            .then((response) => {
                                return response.json();
                            })
                            .then((responseData) => {
                                // Use appropriate value based on audience type
                                const value = audienceType === 'internal' 
                                    ? responseData.internalValue 
                                    : responseData.externalValue;
                                this.setState({ MaxCatchUpContribution: value });
                                this.setState({ error: null });
                            })
                            .catch((err) => {
                                this.setState({ error: err.message });
                                // Keep default value if fetch fails
                            })
                            .finally(() => {
                                fetch(`/api/Inputs`)
                                    .then((response) => {
                                        return response.json();
                                    })
                                    .then((responseData) => {
                                        this.setState({ inputData: responseData });
                                        this.setState({ error: null });
                                    })
                                    .catch((err) => {
                                        this.setState({ error: err.message });
                                        this.setState({ defaultItemData: null });
                                    })
                                    .finally(() => {
                                        this.setState({ isLoading: false });
                                    });
                            });
                    });
            });
    }

    render() {
        return (
            <div id="aspireWrapper">
                {this.state.isLoading && <div>Loading...</div>}
                {this.state.error && (
                    <div>{`There is a problem fetching the post data - ${this.state.error}`}</div>
                )}
                {this.state.helpTextData && !this.state.isLoading &&
                    <>
                        <StartingDialog
                            currentAge={this.state.currentAge}
                            retirementAge={this.state.retirementAge}
                            currentComp={this.state.currentComp}
                            compRate={this.state.compRate}
                            handleModalSubmit={this.handleModalSubmit}
                            showModal={this.state.showModal}
                            updateState={this.updateState}
                            helpTextData={this.state.helpTextData}
                            audience={this.props.audience}
                            inputData={this.state.inputData} />
                        <Container>
                            <Row id="graphWrapper">
                                <Col md={7} xs={12}>
                                    {this.state.showGraph ?
                                        <Graph audience={this.props.audience} helpTextData={this.state.helpTextData} retirementTotal={this.state.totalRetirement} ESOPTotal={this.state.totalESOP} chartData={this.state.chartData} fundsTotal={this.state.totalFunds} />
                                        :
                                        <Row>
                                            <Col>
                                                <div id="graphImageWrapper">
                                                    <BarChart id="graphImage"></BarChart>
                                                </div>
                                            </Col>
                                        </Row>}
                                </Col>
                                <Col md={5} xs={12}>
                                    <Container className="g-0">
                                        <Row>
                                            <Col>
                                                <Inputs
                                                    currentAge={this.state.currentAge}
                                                    retirementAge={this.state.retirementAge}
                                                    currentComp={this.state.currentComp}
                                                    compRate={this.state.compRate}
                                                    updateState={this.updateState}
                                                    deferralPercentage={this.state.deferralPercentage}
                                                    catchUpAmount={this.state.catchUpAmount}
                                                    est401Return={this.state.est401Return}
                                                    current401={this.state.current401}
                                                    assumedPercentageIncreaseShares={this.state.assumedPercentageIncreaseShares}
                                                    assumedPercentageIncreaseDividends={this.state.assumedPercentageIncreaseDividends}
                                                    assumedPercentageIncreaseCash={this.state.assumedPercentageIncreaseCash}
                                                    beginningSharesHeld={this.state.beginningSharesHeld}
                                                    openingCashBalance={this.state.openingCashBalance}
                                                    valueUpDown={this.valueUpDown}
                                                    helpTextData={this.state.helpTextData}
                                                    audience={this.props.audience}
                                                    inputData={this.state.inputData}
                                                    MaxCatchUpContribution={this.state.MaxCatchUpContribution} />
                                            </Col>
                                        </Row>
                                    </Container>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="mt-5 mb-5 text-center font-weight-light footer">
                                    The Aspire Wealth Forecaster and related information is provided for general and educational purposes only. The annual returns used in the calculator are hypothetical and do not and are not intended to predict or project any specific investment results. Past results are not indicative of actual results and do not guarantee future results. Investment return will vary depending upon your investments and market experience. Assumptions do not include fees and expenses. If fees were reflected, the return would be less. Burns & McDonnell and the RPC do not provide investment, tax, or legal advice. The information presented here with the calculator is not specific to any individual's personal circumstances and should not be used solely as a basis for making financial decisions.
                                    <br /><br />Powered by <img title="Burns & McDonnell Logo" src="/BMcD-Logo.png" alt="Burns & McDonnell Logo" />
                                </Col>
                            </Row>
                        </Container>
                    </>}
            </div>


        );
    }
}
